<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div class="padding-ten-tb">
      <b-row style="max-width: 100%">
        <b-col xs="6" sm="6" md="6" lg="6">
          <b-button class="btn-grey" @click="goBack"> Detalle OS </b-button>
        </b-col>
        <b-col xs="6" sm="6" md="6" lg="6" class="text-right">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white">
      <b-row>
        <b-col cols="12">
          <h5 class="text-orange">Datos generales</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey"
            >N° Orden de Servicio</label
          >
          <span>
            {{ detailOS.sequence }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Tienda</label>

          <span>
            {{ detailOS.store }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Fecha creación OS:</label>

          <span>
            {{ detailOS.creationDate }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label for="input-small" class="text-grey">Estado de la OS:</label>

          <span>
            {{ detailOS.status }}
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white">
      <h5 class="text-orange">Datos del cliente</h5>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nombre completo</label>

          <span>
            {{ detailOS.name }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Doc. Identidad</label>

          <span>
            {{ detailOS.identityDocument }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Correo electrónico</label>

          <span>
            {{ detailOS.mail }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Teléfono Principal</label>

          <span>
            {{ detailOS.phone }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Teléfono Secundario</label>

          <span>
            {{ detailOS.phoneSecondary }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Departamento</label>

          <span>
            {{ detailOS.department }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Provincia</label>
          <span>
            {{ detailOS.province }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Distrito</label>

          <span>
            {{ detailOS.district }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Dirección</label>

          <span>
            {{ detailOS.direction }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Referencia</label>
          <span>
            {{ detailOS.reference }}
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="padding-five-all bg-white">
      <h5 class="text-orange">Datos del servicio</h5>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nota de venta</label>

          <span>
            {{ detailOS.sellerNote }}
          </span>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">SKU servicio</label>

          <span>
            {{ detailOS.serviceSku }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Descripción SKU servicio</label
          >
          <span>
            {{ detailOS.serviceDescription }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">SKU producto</label>

          <span>
            {{ detailOS.referenceSku }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Descripción SKU producto</label
          >
          <span>
            {{ detailOS.referenceDescription }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Cantidad</label>
          <span>
            {{ detailOS.quantity }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Fecha estimada del servicio</label
          >
          <span>
            {{ detailOS.estimatedDate }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Turno</label>
          <span>
            {{ detailOS.turn }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Nombre</label>
          <span>
            {{ detailOS.provider }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey">Técnico</label>
          <span>
            {{ detailOS.technician }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Observaciones del cliente</label
          >
          <span>
            {{ detailOS.clientObservation }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3" class="padding-five-bottom">
          <label for="input-small" class="text-grey"
            >Observaciones al proveedor</label
          >
          <span>
            {{ detailOS.providerObservation }}
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "DetailsOS",
  data() {
    return {
      detailOS: {},
      items: [
        {
          text: "Admin. OS",
          to: { name: "AdministracionOs" },
        },
        {
          text: "Detalle OS",
        },
      ],
    };
  },
  computed:{
    ...mapState("module", [
      "token"
    ])
  },
  created() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      this.$store.commit("SET_LOADING", true);
      try {
        const fetchedId = this.$route.params.id;
        if (this.$route.params.id !== fetchedId) return;
        let response = await axios.get(
          process.env.VUE_APP_RECORDS_BUSINESS_BASE +
            "/summaries/children/" +
            this.$route.params.id,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.detailOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.btn-grey {
  background: transparent !important;
  color: #676767 !important;
  border-color: transparent !important;
  font-weight: bolder;
}
.hidden-icon {
  visibility: hidden;
}
@media (max-width: 600px) {
  .xs-hidden {
    display: none;
  }
  .show-icon {
    visibility: visible;
    padding-right: 4px;
  }
}
.color-gray {
  color: #676767;
  font-weight: bold;
}
.padding-ten-lr {
  padding: 10px;
  padding-left: 30px !important;
}
::v-deep .form-control {
  border-color: transparent;
  background: transparent !important;
  text-align: left;
  padding-left: 0;
}
::v-deep.breadcrumb {
  background: transparent !important;
  justify-content: flex-end;
  color: #676767;
  font-weight: bold;
}
a:hover {
  color: rgb(254, 123, 1) !important;
}
a {
  color: #676767 !important;
}
.bg-grey-btn {
  background: #676767;
  color: white;
}

.margin-five-rigth {
  margin-right: 50%;
}

.text-orange {
  color: #ff7a00;
}

::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: white;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}

@media (max-width: 575.98px) {
  .margin-five-rigth {
    margin: 0;
  }
  .padding-five-bottom {
    padding-bottom: 5px;
  }
  .text-grey {
    color: #676767;
    font-size: 15px;
    letter-spacing: 0px;
    display: block;
    margin-bottom: 0.5rem;
  }
}
</style>
